<template>
  <div>
<translation-settings></translation-settings>
  </div>
</template>

<script>
import TranslationSettings from '@/components/admin/TranslationSettings'
  export default {
    name: 'Translations',
    components: {
      TranslationSettings
    }
  }
</script>

<style scoped>

</style>